import React from 'react';
import { Link } from 'react-router-dom';
import { useAtomValue, useAtom } from 'jotai';
import { Typography, Box, Button, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import { stageConfigAtom } from 'atoms/Ltool/stageConfigAtoms';
import { powertrainAtom } from 'atoms/powertrainAtom';
import { gearIdAtom } from 'atoms/gearAtom';
import { GEAR_IDS } from 'utils/constsHev';
import errorImage3 from "assets/dogs/dog3.png";
import { AchievementLevelCalculation } from './subcomponents/AchievementLevelCalculation';
import { FrequencyConversionCalculation } from './subcomponents/FrequencyConversionCalculation';

export const Calculation: React.FC = () => {
    const config = useAtomValue(stageConfigAtom);
    const powertrain = useAtomValue(powertrainAtom);
    const [gearId, setGearId] = useAtom(gearIdAtom);

    const selectedPath = [
        config.project_id,
        config.destination_id,
        config.lot_id,
        config.phase_id,
        config.calculation_id
    ].filter(id => id).join(' / ');

    return (
        <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
                計算設定・計算開始
            </Typography>

            {selectedPath ? (
                <>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        選択中の既存計算セット：{selectedPath}
                    </Typography>

                    {/* HEV は計算が gear 単位。選択中の gear に対して計算する（BEV では非表示） */}
                    {powertrain === 'hev' && (
                        <FormControl sx={{ mb: 2, maxWidth: 240 }}>
                            <InputLabel id="calc-gear-select-label">Gear</InputLabel>
                            <Select
                                labelId="calc-gear-select-label"
                                value={gearId ?? ''}
                                label="Gear"
                                onChange={e => setGearId(e.target.value as string)}
                            >
                                {GEAR_IDS.map(g => (
                                    <MenuItem key={g} value={g}>{g}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}

                    <Stack
                        component="form"
                        spacing={2}
                        noValidate
                        autoComplete="off"
                        direction="column"
                        alignItems="stretch"
                    >
                        <AchievementLevelCalculation />
                        <FrequencyConversionCalculation />
                    </Stack>
                </>
            ) : (
                <>
                    <Typography variant="subtitle1" sx={{ mb: 1, color: 'error.main' }}>
                        既存計算セットが選択されていません。
                    </Typography>
                    <Button
                        component={Link}
                        to="/l-tools/existing-project"
                        variant="outlined"
                        size="small"
                        sx={{ mb: 2 }}
                    >
                        計算セットを選択する
                    </Button>
                    <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
                        <img src={errorImage3} alt="Error" height={400} />
                    </Box>
                </>
            )}
        </Box>
    );
};
